import styled from 'styled-components';
import {
  MIN_PC_BODY_WIDTH,
  MIN_PC_S_BODY_WIDTH,
  MIN_TABLET_BODY_WIDTH,
} from '../../constants/StylistConstants';

const Text = styled.text`
  font-family: 'Poppins';
  font-style: normal;
  text-transform: lowercase;

  color: #000000;
`;

export const TextStylistHeader = styled(Text)<{ fontWeight: number }>`
  font-weight: ${(props) => props.fontWeight};
  font-size: 30px;
  line-height: 45px;

  @media (max-width: ${MIN_PC_S_BODY_WIDTH - 1}px) {
    font-size: 25px;
    line-height: 38px;
  }
`;

export const TextHeader = styled(Text)<{ fontWeight: number }>`
  font-weight: ${(props) => props.fontWeight};
  font-size: 30px;
  line-height: 45px;

  @media (max-width: ${MIN_PC_BODY_WIDTH - 1}px) {
    font-size: 20px;
    line-height: 30px;
  }
`;

export const TextRegular = styled(Text)<{ fontWeight: number }>`
  font-weight: ${(props) => props.fontWeight};
  font-size: 18px;
  line-height: 27px;

  @media (max-width: ${MIN_PC_S_BODY_WIDTH - 1}px) {
    font-size: 16px;
    line-height: 24px;
  }

  @media (max-width: ${MIN_TABLET_BODY_WIDTH - 1}px) {
    font-size: 14px;
    line-height: 21px;
  }
`;

export const TextLabel = styled(Text)<{ fontWeight: number }>`
  font-weight: ${(props) => props.fontWeight};
  font-size: 16px;
  line-height: 24px;

  @media (max-width: ${MIN_PC_BODY_WIDTH - 1}px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const TextGarmentPreview = styled(Text)`
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;

  @media (max-width: ${MIN_PC_S_BODY_WIDTH - 1}px) {
    font-size: 13px;
    line-height: 20px;
  }
`;
